import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Note } from '../../../../calvin-emr-shared/models/note.model';
import { Timestamp } from '@firebase/firestore';
import { EditorModule } from 'primeng/editor';
import { DatePicker } from 'primeng/datepicker';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";

@Component({
  selector: 'app-rich-text-form',
  templateUrl: './rich-text-form.component.html',
  styleUrls: ['./rich-text-form.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    DatePicker,
    EmrInputComponent
  ],
})
export class RichTextFormComponent implements OnInit {
  form = this.fb.group({
    title: ['', Validators.required],
    note: ['', Validators.required],
    date: ['', Validators.required],
    signature: ['', Validators.required],
  });

  @Input() note?: Note;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.prefillForm();
  }

  /**
   * Used to emit note objects up to the parent component.
   */
  @Output() noteEvent = new EventEmitter<Note>();

  /**
   * If the form is specified to be prefilled (for example, when a note is being edited),
   * set all values in the form to match those of the provided ProgressNote.
   * ngOnInit must be used to set the form; otherwise, the form's value will be set before
   * the Note object is passed to the NoteForm component.
   */
  private prefillForm() {
    // For pre-filling form in OrderEditDialogComponent
    if (this.note !== undefined && this.note !== null) {
      const date = this.note.simDateCreated.toDate();
      this.dateFormControl.setValue(date);

      this.form.patchValue({
        title: this.note.title,
        note: this.note.content,
        signature: this.note.signature,
      });
    }
  }

  /**
   * Retrieves and formats data from the form to put into a ProgressNote object.
   *
   * @returns A new ProgressNote with values taken from the form.
   */
  public getNoteFromForm(options?: { partOfOrderSet: boolean }): Note {
    let id = '' + Date.now();
    const title = this.titleFormControl.value.trim();
    const simDateCreated = Timestamp.fromDate(new Date(this.dateFormControl.value));
    const signature = this.signatureFormControl.value.trim();
    let dateCreated = Timestamp.now();

    if (this.isPrefilled && this.note) {
      id = this.note.id;
      dateCreated = this.note?.dateCreated;
    }

    const partOfOrderSet = (options && options.partOfOrderSet);

    return new Note(id, simDateCreated, title, this.noteFormControl.value,
      signature, dateCreated, partOfOrderSet
    );
  }

  get isPrefilled() {
    return this.note !== undefined && this.note !== null;
  }

  get titleFormControl(): UntypedFormControl {
    return this.form.controls.title as UntypedFormControl;
  }

  get noteFormControl(): UntypedFormControl {
    return this.form.controls.note as UntypedFormControl;
  }

  get dateFormControl(): UntypedFormControl {
    return this.form.controls.date as UntypedFormControl;
  }

  get signatureFormControl(): UntypedFormControl {
    return this.form.controls.signature as UntypedFormControl;
  }
}
